<template>
  <div>
    <h3 class="mb-5 tracking-wide md:mb-4 md:text-[22px] md:text-xl">Payment Details</h3>
    <!-- カード欄は新動線の S4 と共有する。新動線は見出しをアコーディオン側が出すので、見出しだけここに持つ -->
    <CreditCardFields :payment-error-messages="paymentErrorMessages" :payment-method="paymentMethod" />
  </div>
</template>

<script lang="ts" setup>
import type { PaymentMethod } from '@/wabunka-src/constants/paymentMethod';
import CreditCardFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/CreditCardFields/CreditCardFields.vue';

interface Props {
  paymentErrorMessages: string[];
  paymentMethod: PaymentMethod;
}

defineProps<Props>();
</script>
